import React, { useContext, useEffect, useState } from "react";
import "./Relevent_news_update.css";
import Common_Heading from "../../../../common_components/common_Heading/Common_Heading";
import Relevent_news_update_card from "./relevent_news_update_card/Relevent_news_update_card";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination } from "swiper/modules";
import "swiper/css/pagination";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../../../utils/context";
import { luxuryLatestNews } from "../../../../../utils/luxuryapis/Home/Homeapi";

function Relevent_news_update({ currentId }) {
  const [relevantNews, setRelevantNews] = useState([]);
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);

  useEffect(() => {
    luxuryLatestNews().then((res) => {
      if (res?.success) {
        const fiteredNews = res.data.filter(
          (item) => String(item.id) != String(currentId),
        );
        setRelevantNews(fiteredNews);
      }
    });
  }, [currentId]);

  if (!relevantNews.length) return null;
  return (
    <>
      <section className="Relevent_news_update">
        <div className="custom_container">
          <Common_Heading headingText={"RELEVANT NEWS UPDATES"} />
          <div className="Relevent_news_update_holder">
            <Swiper
              spaceBetween={10}
              slidesPerView={5.4}
              modules={[Pagination]}
              pagination={{ clickable: true }}
              className="Relevent_news_update_swiper"
              breakpoints={{
                0: {
                  slidesPerView: 1.2,
                  spaceBetween: 10,
                },
                576: {
                  slidesPerView: 2.2,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3.2,
                  spaceBetween: 10,
                },
                992: {
                  slidesPerView: 4.2,
                  spaceBetween: 10,
                },
                1200: {
                  slidesPerView: 5.4,
                  spaceBetween: 10,
                },
              }}
            >
              {relevantNews.map((item) => (
                <SwiperSlide key={item.id}>
                  <Relevent_news_update_card
                    data={item}
                    imgSrc={IMG_URL + item.image}
                    onClick={() =>
                      navigate(`/luxury/latest-news-details/${item.id}`)
                    }
                  />
                </SwiperSlide>
              ))}
              {/* 
              <SwiperSlide>
                <Relevent_news_update_card imgSrc="/assest/luxury_images/in_company/latest_news/latest_updates/img_2.png" />
              </SwiperSlide>

              <SwiperSlide>
                <Relevent_news_update_card imgSrc="/assest/luxury_images/in_company/latest_news/latest_updates/img_1.png" />
              </SwiperSlide>

              <SwiperSlide>
                <Relevent_news_update_card imgSrc="/assest/luxury_images/in_company/latest_news/latest_updates/img_2.png" />
              </SwiperSlide>

              <SwiperSlide>
                <Relevent_news_update_card imgSrc="/assest/luxury_images/in_company/latest_news/latest_updates/img_1.png" />
              </SwiperSlide>

              <SwiperSlide>
                <Relevent_news_update_card imgSrc="/assest/luxury_images/in_company/latest_news/latest_updates/img_2.png" />
              </SwiperSlide> */}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}

export default Relevent_news_update;
